var mentions_default = {
  "mentionPalette": "XWE7W",
  "mention": "_7twCr",
  "mentionViewer": "UjAhc",
  "mentionSuggestionsEntry": "wrN84",
  "mentionSuggestionsEntryFocused": "rNvL0",
  "mentionSuggestionsEntryText": "l3MPe",
  "mentionSuggestionsEntryAvatar": "fJGsc",
  "mentionSuggestions": "LzLyX",
  "cursorDefault": "SnufB",
  "cursorPointer": "J2ayI"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
